export default class PromotionAction {
    static PROMOTION_TYPE_REQUEST = 'PROMOTION_TYPE_REQUEST';
    static PROMOTION_TYPE_SUCCESS = 'PROMOTION_TYPE_SUCCESS';
    static PROMOTION_TYPE_FAILED = 'PROMOTION_TYPE_FAILED';



    static promotionType_Request() {
        return {
            type: this.PROMOTION_TYPE_REQUEST
        }
    }

    static promotionType_Success (data) {
        return {
            type: this.PROMOTION_TYPE_SUCCESS,
            data
        }
    }

    static promotionType_Failed (error) {
        return {
            type: this.PROMOTION_TYPE_FAILED,
            error
        }
    }


        // PROMOTION LEVEL

    static PROMOTION_LEVEL_REQUEST = 'PROMOTION_LEVEL_REQUEST';
    static PROMOTION_LEVEL_SUCCESS = 'PROMOTION_LEVEL_SUCCESS';
    static PROMOTION_LEVEL_FAILED = 'PROMOTION_LEVEL_FAILED';

    static promotionLevel_Request() {
        return {
            type: this.PROMOTION_LEVEL_REQUEST
        }
    }

    static promotionLevel_Success (data) {
        return {
            type: this.PROMOTION_LEVEL_SUCCESS,
            data
        }
    }

    static promotionLevel_Failed (error) {
        return {
            type: this.PROMOTION_LEVEL_FAILED,
            error
        }
    }
     
    // DOWNLAOD PROMOTION CSV
    static DOWNLOAD_PROMO_CSV_REQUEST = 'DOWNLOAD_PROMO_CSV_REQUEST';
    static DOWNLOAD_PROMO_CSV_SUCCESS = 'DOWNLOAD_PROMO_CSV_SUCCESS';
    static DOWNLOAD_PROMO_CSV_FAILED = 'DOWNLOAD_PROMO_CSV_FAILED';

    static downlaod_promo_csv_Request(data) {
        return {
            type: this.DOWNLOAD_PROMO_CSV_REQUEST,
            data
        }
    }

    static downlaod_promo_csv_Success(data) {
        return {
            type: this.DOWNLOAD_PROMO_CSV_SUCCESS,
            data
        }
    }

    static downlaod_promo_csv_Failed(error) {
        return {
            type: this.DOWNLOAD_PROMO_CSV_FAILED,
            error
        }
    }
     
    // CALCULATE PREOSPO FROM CSV ACTIONS
    static CALCULATE_PROMO_CSV_REQUEST = 'CALCULATE_PROMO_CSV_REQUEST';
    static CALCULATE_PROMO_CSV_SUCCESS = 'CALCULATE_PROMO_CSV_SUCCESS';
    static CALCULATE_PROMO_CSV_FAILED = 'CALCULATE_PROMO_CSV_FAILED';

    static calculate_promo_csv_Request(data) {
        return {
            type: this.CALCULATE_PROMO_CSV_REQUEST,
            data
        }
    }

    static calculate_promo_csv_Success(data) {
        return {
            type: this.CALCULATE_PROMO_CSV_SUCCESS,
            data
        }
    }

    static calculate_promo_csv_Failed(error) {
        return {
            type: this.CALCULATE_PROMO_CSV_FAILED,
            error
        }
    }

}